import { UI_STYLES } from "@/styles/uiStyles";

interface SubscriptionConditionsModalContentProps {
  setIsConditionsOpen: (isOpen: boolean) => void;
}

export const SubscriptionConditionsModalContent = ({
  setIsConditionsOpen,
}: SubscriptionConditionsModalContentProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full ">
      <div className=" text-white text-sm leading-relaxed p-4 text-center mb-6 hide-scrollbar max-h-[300px] overflow-y-auto">
        <ul className="list-disc list-inside text-start gap-2">
      <li className="mb-2">
       Вы можете отменить подписку в любое время.
      </li>
      <li className="mb-2">
       Оплата осуществляется при подтверждении приобретения подписки.
      </li>
      <li className="mb-2">
       Подписка автоматически продлевается, если не была отменена самим пользователем не менее чем за 24 часа до окончания текущего срока действия.
      </li>
      <li className="mb-2">
       Денежные средства списываются с учетной записи пользователя в течение 24 часов до окончания текущего срока действия подписки, с указанием цены и длительности.
      </li>
        <li className="mb-2">
       В наших планах подписки нет бесплатных пробных версий или ознакомительных цен.
      </li>
      <li className="mb-2">
       Если у вас возникли проблемы с продлением после истечения срока действия подписки, она останется активной в течение 7 дней, пока не будет отменена.
      </li>
      </ul>
      </div>
      <button
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} hover:bg-cyan-700 text-white  rounded-xl py-3 mb-2 transition`}
        onClick={() => setIsConditionsOpen(false)}
      >
        Понятно
      </button>
    </div>
  );
};
